<div
  class="emds"
  [ngClass]="{
    required: isRequired(),
    error: (findControlFormControl && findControlFormControl.invalid && checkIfParentFormGroupHasToBeSubmitted()) ||
    (formGroup?.get(controlName)?.invalid && formGroup?.get(controlName)?.errors?.autoWriteoffAdjType),
    'required-invalid':
      ((!!form ? form?.submitted : formGroupSubmitted) && findControlFormControl?.invalid) ||
      (findControlFormControl?.invalid && checkIfParentFormGroupHasToBeSubmitted()) ||
      (formGroup?.get(controlName)?.invalid && formGroup?.get(controlName)?.errors?.autoWriteoffAdjType),
    showRequiredOnly: isShowRequiredOnly(),
    isnotallowed: disabled || !findControlId
  }"
>
  <mat-form-field
    [ngClass]="{ expand: shouldExpand() }"
    appearance="outline"
    class="emds-find-control"
    id="{{ baseId }}-form-field"
    (click)="findControlClicked($event)"
  >
    <mat-chip-list #chipList [disabled]="disabled || !findControlId" matPrefix>
      <mat-chip [disabled]="disabled || !findControlId" [selectable]="selectable" *ngIf="loadingItems || loadingConfig">
        <ap-spinner size="1"></ap-spinner>
      </mat-chip>
      <ng-container *ngIf="!loadingConfig && !loadingItems">
        <mat-chip class="mat-chip-counter" *ngIf="!singleSelect && autoCompleteOpen">
          {{ '+' + chips.length }}
        </mat-chip>
        <mat-chip
          *ngFor="let chip of chips"
          (click)="findControlClicked()"
          [disabled]="disabled || !findControlId"
          [selectable]="selectable"
          [removable]="removable"
          [hidden]="!singleSelect && autoCompleteOpen"
          (removed)="removeChip(chip)"
        >
          <div class="chip-name-container">
            {{ getChipDisplayName(chip) }}
          </div>
          <button matChipRemove id="{{ baseId }}-{{ chip.Pk }}-remove" *ngIf="removable && !disabled">
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </ng-container>
    </mat-chip-list>
    <input
      placeholder="{{ this.chips && this.chips.length < 1 ? this.placeHolder : '' }}"
      [readonly]="disabled || !findControlId"
      #chipInput
      (blur)="inputBlurred()"
      (focus)="inputFocused()"
      [formControl]="autoCompleteFormControl"
      [matChipInputFor]="chipList"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      [matChipInputAddOnBlur]="addOnBlur"
      [matAutocomplete]="auto"
      [maxlength]="findControlMaxLength"
      type="text"
      id="{{ baseId }}-input"
      name="{{ baseId }}-input"
      class="emds-find-control-text-input"
    />
    <mat-autocomplete
      class="emds"
      autoActiveFirstOption
      #auto="matAutocomplete"
      (optionSelected)="chipSelectedFromAutoComplete($event)"
      (opened)="onAutoCompleteOpen()"
      (closed)="onAutoCompleteClose()"
    >
      <mat-option *ngIf="loadingData" class="loading-option" [disabled]="true">
        <ap-spinner size="2"></ap-spinner>
      </mat-option>
      <mat-optgroup
        class="find-control-dropdown-group"
        [hidden]="loadingData || !group.Name"
        *ngFor="let group of autocompleteGroups$ | async"
        [label]="group.Name"
      >
        <span *ngIf="group.isCollapsable" class="center-icon pull-right" id="{{ baseId }}-toggle-collapse" (click)="toggleCollapsed($event, group)">
          <div class="ap-down-chevron" *ngIf="group.isCollapsed" #matOptgroupLabel></div>
          <div class="ap-up-chevron" *ngIf="!group.isCollapsed" #matOptgroupLabel></div>
        </span>
        <mat-option *ngFor="let option of group.ItemList" [hidden]="group.isCollapsed" [disabled]="group.GroupDisabled" [value]="option">
          {{ getAutocompleteDisplayName(option) }}
        </mat-option>
        <mat-option *ngIf="!group.ItemList.length && !group.isCollapsed" [disabled]="true" translate> No items available </mat-option>
      </mat-optgroup>
    </mat-autocomplete>
    <mat-icon
      #openModalButton
      matSuffix
      class="emds-find-control-icon"
      [class.disabled]="disabled || !findControlId"
      [class.clickable]="!disabled && !!findControlId"
      id="{{ baseId }}-search"
      (click)="openModal()"
      >search</mat-icon
    >
  </mat-form-field>
  <div class="incorrect-input" *ngIf="formGroup?.get(controlName)?.invalid && formGroup?.get(controlName)?.errors?.autoWriteoffAdjType">
    {{ formGroup?.get(controlName)?.errors | fcListValidation }}
  </div>
  <div class="incorrect-input"
       id="{{(findControlDisplayName || findControlDto?.FindControlBehavior?.Name)}}-error-text-required"
       *ngIf="(isRequired() && form?.submitted && findControlFormControl?.invalid) ||
              (findControlFormControl?.invalid && checkIfParentFormGroupHasToBeSubmitted() && !formGroup?.get(controlName)?.errors?.autoWriteoffAdjType)"
  >
  {{ (setErrorFindControlDisplayName() || findControlDto?.FindControlBehavior?.Name) + ' is a required field' }}
  </div>
</div>
